import script from "./LawFirmForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./LawFirmForm.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__